import React from "react";

function OrderIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="30.796"
      viewBox="0 0 32 30.796"
      {...props}
    >
      <g id="Order" transform="translate(-296.495 -114.08)">
        <path
          id="Path_422"
          data-name="Path 422"
          d="M3497.495-3471.348c4.979,5.435,6.287,6.4,10.282,10.224,2.973-2.771,4.554-6.756,10.734-9.472,2.18-1.229,5.61-2.365,8.984-9-4.794-4.381-6.166-5.612-11.484-10.327-2.646,3.951-5.263,7.981-8.243,8.712C3500.933-3479.739,3497.495-3471.348,3497.495-3471.348Z"
          transform="translate(-3200 3605)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_18"
          data-name="Line 18"
          y1="4.085"
          x2="4.085"
          transform="translate(313.023 119.508)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Line_19"
          data-name="Line 19"
          y1="4.085"
          x2="4.085"
          transform="translate(307.304 135.758)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <text
          id="_"
          data-name="$"
          transform="translate(313.854 131.856) rotate(-43)"
          fill="currentColor"
          fontSize="10"
          fontFamily="Helvetica"
        >
          <tspan x="-2" y="0">
            $
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default OrderIcon;
